/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import styled from 'styled-components';
import theme from '../../styles/theme';


const HitWrapper = styled.article`
  height: 100%;
  padding: 12px 12px;

  mark {
    background-color: ${theme.background.blue};
    color: ${theme.textColor.white};
  }
`;
HitWrapper.displayName = 'HitWrapper';

/*------------------------------------------------*/
/* EXPORTS
/*------------------------------------------------*/
export default HitWrapper;
